<template>
  <div class="well">
    <div class="inner-well">
      <div class="row">
        <div class="col-md-4 col-md-offset-1">
          <label for="wax_type">Step 1: Choose Your Wax</label>
          <select id="wax_type"
                  :value="currentWax && currentWax.name"
                  name="wax_type"
                  class="form-control"
                  @change="selectWax"
          >
            <option value="">Select a Wax...</option>
            <optgroup v-for="waxGroup in availableWaxesInGroups"
                      :key="waxGroup.name"
                      :label="waxGroup.name"
            >
              <option v-for="wax in waxGroup.waxes"
                      :key="wax.name"
                      :value="wax.name"
              >
                {{ wax.name }}
              </option>
            </optgroup>
          </select>
        </div>

        <div class="col-md-4 col-md-offset-2">
          <template v-if="currentWax">
            <label class="size-label" for="pillar_size">Step 2: Choose Your Diameter</label>
            <select id="pillar_size"
                    name="pillar_size"
                    class="form-control"
                    :value="currentSize"
                    @change="selectSize"
            >
              <option :selected="currentWax === null" value="">Container sizes...</option>
              <option v-for="size in availableSizes" :key="size" :value="size">
                {{ size }}
              </option>
            </select>
          </template>
        </div>
      </div>
    </div>

    <template v-if="currentWick">
      <div class="answers">
        <p class="answer">
          Our Pick:
          <template v-if="currentWick.firstRow.url">
            <a :href="currentWick.firstRow.url">
              {{ currentWick.firstRow.name }}
            </a>
          </template>
          <template v-else>
            {{ currentWick.firstRow.name }}
          </template>
          {{ currentWick.firstRow.suffix }}
        </p>
        <template v-if="currentWick.multipleRows">
          <p class="answer">
            Runner-up:
            <a :href="currentWick.secondRow.url">
              {{ currentWick.secondRow.name }}
            </a>
            {{ currentWick.secondRow.suffix }}
          </p>
        </template>
        <span class="reset-btn" @click="clearSelections">
          <a href="#" class="btn btn-default">Find a New Wick</a>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
  import concat from 'lodash/concat'
  import flatMap from 'lodash/flatMap'
  import find from 'lodash/find'
  import { containerWaxes, pillarWaxes } from 'lib/storefront/wick-guide/data-points.js'

  const allWaxGroups = concat(containerWaxes, pillarWaxes);
  const allWaxes = flatMap(allWaxGroups, (waxGroup) => { return waxGroup.waxes; });

  export default {
    data() {
      return {
        currentWax: null,
        currentSize: null,
      };
    },
    computed: {
      availableWaxesInGroups() {
        return allWaxGroups;
      },
      availableSizes() {
        return this.currentWax ? this.currentWax.sizes : [];
      },
      currentWick() {
        if (this.currentWax && this.currentSize) {
          return this.currentWax.findWick(this.currentSize);
        }
        return null;
      }
    },
    methods: {
      selectWax(event) {
        this.currentWax = find(allWaxes, (wax) => {
          return wax.name === event.target.value;
        });
        this.currentSize = null;
      },
      selectSize(event) {
        this.currentSize = event.target.value;
      },
      clearSelections() {
        this.currentWax = null;
        this.currentSize = null;
      }
    }
  }
</script>
